import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRadioChecked = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 3.75,
			y: 3.75,
			width: 16.5,
			height: 16.5,
			rx: 8.25,
			stroke: "url(#paint0_linear_2235_15513)",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 6,
			fill: "url(#paint1_linear_2235_15513)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_2235_15513",
			x1: 4.20578,
			y1: -.862517,
			x2: 14.6213,
			y2: 20.7545,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#80B344" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#5A8D1D"
			})]
		}), /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_2235_15513",
			x1: 6.80385,
			y1: 3.42499,
			x2: 13.7475,
			y2: 17.8363,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#80B344" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#5A8D1D"
			})]
		})] })
	]
});
export default SvgRadioChecked;
